






























import { Component, Prop, Vue, Emit } from "vue-property-decorator";
import { PartialDictionary } from "vee-validate";
import { ParticaEvent, eParticaAction } from "../../../Models/ParticaEvent";

@Component
export default class Dropzone extends Vue {
	@Prop({ default: true }) private enabled!: boolean;
	@Prop({ default: false }) private multiple: boolean;
	private hightlight = false;

	private openFileSelection(): void {
		if (!this.enabled) { return; }
		(this.$refs.fileInput as HTMLElement).click();
	}

	private onDragOver(event: DragEvent): void {
		if (!this.enabled) { return; }
		event.preventDefault();
		this.hightlight = true;
	}

	private onDragLeave(event: DragEvent): void {
		this.hightlight = false;
	}

	private onDrop(event: DragEvent): void {
		if (!this.enabled) { return; }
		event.preventDefault();
		if (event.dataTransfer !== null) {
			const files = event.dataTransfer.files;
			const result: File[] = [];
			for (let i = 0; i < files.length; i++) {
				result.push(files.item(i) as File);
			}
			this.$emit("filesAdded", result);
			this.hightlight = false;
		}
	}

	private onFileChanged(event: any) {
		const files: FileList = event.target.files;
		const result: File[] = [];
		for (let i = 0; i < files.length; i++) {
			result.push(files.item(i) as File);
		}
		this.$emit("filesAdded", result);
	}
}
